
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"21","viewBox":"0 0 40 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"39.25","height":"7.85","rx":"3.925","fill":"#000"}}),_c('rect',{attrs:{"y":"11.775","width":"39.25","height":"7.85","rx":"3.925","fill":"#000"}}),_c('rect',{attrs:{"y":"23.55","width":"39.25","height":"7.85","rx":"3.925","fill":"#000"}})])
          )
        }
      }
    